import type { ReactNode } from 'react'

export interface DLRow { label: ReactNode; value: ReactNode }

/** Key Information panel — label/value pairs (record left-rail). */
export function DescriptionList({ rows, columns = 1 }: { rows: DLRow[]; columns?: 1 | 2 }) {
  return (
    <dl className={`dl dl--${columns}`}>
      {rows.map((r, i) => (
        <div key={i} className="dl-row">
          <dt className="dl-label label">{r.label}</dt>
          <dd className="dl-value">{r.value ?? <span className="dim">—</span>}</dd>
        </div>
      ))}
    </dl>
  )
}
